export default {
  gmail: 'google',
  outlook: 'office365',
  outlookGccHigh: 'office365gcchigh'
};